import React from 'react';
import { Gift } from 'lucide-react';
const BONUSES = [{
  id: 1,
  title: 'REGALO #1',
  subtitle: 'Guía Maestra de Planificación Anual',
  description: 'Planificaciones listas y estructuradas para los 6 libros.',
  image: 'https://cdn.magicpatterns.com/uploads/mvv4JXcaYQaeLS1ZP3w4U5/38.png',
  color: 'bg-blue-600'
}, {
  id: 2,
  title: 'REGALO #2',
  subtitle: 'Pack de Mapas Educativos',
  description: 'Mapas ilustrados y actualizados de todo el mundo.',
  image: 'https://cdn.magicpatterns.com/uploads/83BNaxkBbs9FdegfaLi2tZ/39.png',
  color: 'bg-pink-600'
}, {
  id: 3,
  title: 'REGALO #3',
  subtitle: 'Guía de Primeros Auxilios Escolares',
  description: 'Cómo actuar ante emergencias: desmayos, golpes, cortes y crisis nerviosas.',
  image: 'https://cdn.magicpatterns.com/uploads/w3EraMNudLsh5MHNy1KVTj/40.png',
  color: 'bg-red-600'
}];
export function Bonuses({
  onScrollToPurchase
}: {
  onScrollToPurchase: () => void;
}) {
  return <section className="py-16 bg-sky-50" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-4">
            ¡PERO ESO NO ES TODO!
          </h2>
          <p className="text-xl text-blue-600 font-medium" data-id="element-5">
            🎁 Accediendo hoy te llevás estos bonos GRATIS:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6">
          {BONUSES.map(bonus => <div key={bonus.id} className="group cursor-pointer transform transition-transform hover:scale-105" onClick={onScrollToPurchase} data-id="element-7">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden h-full flex flex-col" data-id="element-8">
                <div className="relative aspect-square bg-gray-100" data-id="element-9">
                  <img src={bonus.image} alt={bonus.subtitle} className="w-full h-full object-cover" data-id="element-10" />
                  <div className="absolute top-4 right-4 bg-blue-600 text-white font-bold px-3 py-1 rounded-full shadow-md text-sm" data-id="element-11">
                    GRATIS HOY
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-12">
                  <div className={`inline-block self-start px-3 py-1 rounded-md text-white text-xs font-bold mb-3 ${bonus.color}`} data-id="element-13">
                    {bonus.title}
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight" data-id="element-14">
                    {bonus.subtitle}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-15">{bonus.description}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}